import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UndergroundProperties } from '../../state/edge.model';

@Component({
  selector: 'app-edge-duct-diagram',
  templateUrl: './edge-duct-diagram.component.html'
})
export class EdgeDuctDiagramComponent implements OnInit {

  @Input()
  properties: UndergroundProperties;

  size = 376;
  headerHeight = 50;
  footerHeight = 50;

  debug = false; // !environment.production;

  constructor() { }

  ngOnInit(): void {
  }

  get base(): number {
    return this.properties.ducts.length;
  }

  get columns(): number {
    return this.properties.ducts[0].length;
  }

  get scale(): number {
    const side = this.width > this.height ? this.width : this.height;
    return this.size / side;
  }

  get width(): number {
    return this.base < 4 ? this.size : this.base * 100;
  }

  get height(): number {
    const height = this.columns < 4 ? this.size : this.columns * 100;
    return height + this.headerHeight + this.footerHeight;
  }

}
